import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';

export default
@observer
class HospitalHealthFundDisclaimer extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    hfDisclaimerText(name) {
        return `<span>Please check that your Hospitals policy covers the services you require. Contact the practitioner to confirm their services are eligible for claiming with <strong>${name}</strong></span>`;
    }

    searchDisclaimerText(name) {
        return `<span><strong>${name}</strong> does not endorse any hospitals listed below.</span>`;
    }

    render() {
        const {
            paramStore: {hasSkin},
            healthFundStore: {healthFund},
        } = this.context.rootStore;
        if (!healthFund?.name || hasSkin) {
            return null;
        }
        const {avatar} = healthFund;

        return (
            <>
                <small className="disclaimer">
                    {!hasSkin && <img src={avatar} />}

                    <p
                        dangerouslySetInnerHTML={{
                            __html: this.hfDisclaimerText(healthFund.name),
                        }}
                    ></p>
                </small>
                <small
                    className="disclaimer"
                    dangerouslySetInnerHTML={{
                        __html: this.searchDisclaimerText(healthFund.name),
                    }}
                ></small>
            </>
        );
    }
}
